import { SET_CATEGORIES } from "../constants/Constants";

const initialState = {
  categories: null, // { men: [], women: [] }
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CATEGORIES:
      return { ...state, categories: action.payload };
    default:
      return state;
  }
};

export default categoryReducer;
